import { useMatches } from '@remix-run/react';

export const useCurrentTabPath = () => {
    const matches = useMatches();
    const currentTabPath =
        matches[matches.length - 1]?.pathname.split('/').pop() || 'overview';

    return currentTabPath;
};
